const l = {
  sm: {
    1: "grid-cols-1",
    2: "grid-cols-2",
    3: "grid-cols-3",
    4: "grid-cols-4",
    5: "grid-cols-5",
    6: "grid-cols-6",
    7: "grid-cols-7",
    8: "grid-cols-8",
    9: "grid-cols-9",
    10: "grid-cols-10",
    11: "grid-cols-11",
    12: "grid-cols-12"
  },
  md: {
    1: "md:grid-cols-1",
    2: "md:grid-cols-2",
    3: "md:grid-cols-3",
    4: "md:grid-cols-4",
    5: "md:grid-cols-5",
    6: "md:grid-cols-6",
    7: "md:grid-cols-7",
    8: "md:grid-cols-8",
    9: "md:grid-cols-9",
    10: "md:grid-cols-10",
    11: "md:grid-cols-11",
    12: "md:grid-cols-12"
  },
  lg: {
    1: "lg:grid-cols-1",
    2: "lg:grid-cols-2",
    3: "lg:grid-cols-3",
    4: "lg:grid-cols-4",
    5: "lg:grid-cols-5",
    6: "lg:grid-cols-6",
    7: "lg:grid-cols-7",
    8: "lg:grid-cols-8",
    9: "lg:grid-cols-9",
    10: "lg:grid-cols-10",
    11: "lg:grid-cols-11",
    12: "lg:grid-cols-12"
  }
}, s = {
  sm: {
    xs: "gap-2",
    sm: "gap-4",
    md: "gap-5",
    lg: "gap-6",
    xl: "gap-6",
    "2xl": "gap-8"
  },
  md: {
    xs: "md:gap-2",
    sm: "md:gap-4",
    md: "md:gap-5",
    lg: "md:gap-6",
    xl: "md:gap-6",
    "2xl": "md:gap-8"
  },
  lg: {
    xs: "lg:gap-2",
    sm: "lg:gap-4",
    md: "lg:gap-5",
    lg: "lg:gap-6",
    xl: "lg:gap-6",
    "2xl": "lg:gap-8"
  }
}, e = {
  sm: {
    xs: "gap-x-2",
    sm: "gap-x-4",
    md: "gap-x-5",
    lg: "gap-x-6",
    xl: "gap-x-6",
    "2xl": "gap-x-8"
  },
  md: {
    xs: "md:gap-x-2",
    sm: "md:gap-x-4",
    md: "md:gap-x-5",
    lg: "md:gap-x-6",
    xl: "md:gap-x-6",
    "2xl": "md:gap-x-8"
  },
  lg: {
    xs: "lg:gap-x-2",
    sm: "lg:gap-x-4",
    md: "lg:gap-x-5",
    lg: "lg:gap-x-6",
    xl: "lg:gap-x-6",
    "2xl": "lg:gap-x-8"
  }
}, r = {
  sm: {
    xs: "gap-y-2",
    sm: "gap-y-4",
    md: "gap-y-5",
    lg: "gap-y-6",
    xl: "gap-y-6",
    "2xl": "gap-y-8"
  },
  md: {
    xs: "md:gap-y-2",
    sm: "md:gap-y-4",
    md: "md:gap-y-5",
    lg: "md:gap-y-6",
    xl: "md:gap-y-6",
    "2xl": "md:gap-y-8"
  },
  lg: {
    xs: "lg:gap-y-2",
    sm: "lg:gap-y-4",
    md: "lg:gap-y-5",
    lg: "lg:gap-y-6",
    xl: "lg:gap-y-6",
    "2xl": "lg:gap-y-8"
  }
}, t = {
  sm: {
    1: "col-span-1",
    2: "col-span-2",
    3: "col-span-3",
    4: "col-span-4",
    5: "col-span-5",
    6: "col-span-6",
    7: "col-span-7",
    8: "col-span-8",
    9: "col-span-9",
    10: "col-span-10",
    11: "col-span-11",
    12: "col-span-12"
  },
  md: {
    1: "md:col-span-1",
    2: "md:col-span-2",
    3: "md:col-span-3",
    4: "md:col-span-4",
    5: "md:col-span-5",
    6: "md:col-span-6",
    7: "md:col-span-7",
    8: "md:col-span-8",
    9: "md:col-span-9",
    10: "md:col-span-10",
    11: "md:col-span-11",
    12: "md:col-span-12"
  },
  lg: {
    1: "lg:col-span-1",
    2: "lg:col-span-2",
    3: "lg:col-span-3",
    4: "lg:col-span-4",
    5: "lg:col-span-5",
    6: "lg:col-span-6",
    7: "lg:col-span-7",
    8: "lg:col-span-8",
    9: "lg:col-span-9",
    10: "lg:col-span-10",
    11: "lg:col-span-11",
    12: "lg:col-span-12"
  }
}, d = {
  sm: {
    1: "col-start-1",
    2: "col-start-2",
    3: "col-start-3",
    4: "col-start-4",
    5: "col-start-5",
    6: "col-start-6",
    7: "col-start-7",
    8: "col-start-8",
    9: "col-start-9",
    10: "col-start-10",
    11: "col-start-11",
    12: "col-start-12"
  },
  md: {
    1: "md:col-start-1",
    2: "md:col-start-2",
    3: "md:col-start-3",
    4: "md:col-start-4",
    5: "md:col-start-5",
    6: "md:col-start-6",
    7: "md:col-start-7",
    8: "md:col-start-8",
    9: "md:col-start-9",
    10: "md:col-start-10",
    11: "md:col-start-11",
    12: "md:col-start-12"
  },
  lg: {
    1: "lg:col-start-1",
    2: "lg:col-start-2",
    3: "lg:col-start-3",
    4: "lg:col-start-4",
    5: "lg:col-start-5",
    6: "lg:col-start-6",
    7: "lg:col-start-7",
    8: "lg:col-start-8",
    9: "lg:col-start-9",
    10: "lg:col-start-10",
    11: "lg:col-start-11",
    12: "lg:col-start-12"
  }
}, o = {
  sm: {
    row: "grid-flow-row",
    column: "grid-flow-col",
    "row-dense": "grid-flow-row-dense",
    "column-dense": "grid-flow-col-dense"
  },
  md: {
    row: "md:grid-flow-row",
    column: "md:grid-flow-col",
    "row-dense": "md:grid-flow-row-dense",
    "column-dense": "md:grid-flow-col-dense"
  },
  lg: {
    row: "lg:grid-flow-row",
    column: "lg:grid-flow-col",
    "row-dense": "lg:grid-flow-row-dense",
    "column-dense": "lg:grid-flow-col-dense"
  }
}, g = {
  sm: {
    normal: "justify-normal",
    start: "justify-start",
    end: "justify-end",
    center: "justify-center",
    between: "justify-between",
    around: "justify-around",
    evenly: "justify-evenly",
    stretch: "justify-stretch"
  },
  md: {
    normal: "md:justify-normal",
    start: "md:justify-start",
    end: "md:justify-end",
    center: "md:justify-center",
    between: "md:justify-between",
    around: "md:justify-around",
    evenly: "md:justify-evenly",
    stretch: "md:justify-stretch"
  },
  lg: {
    normal: "lg:justify-normal",
    start: "lg:justify-start",
    end: "lg:justify-end",
    center: "lg:justify-center",
    between: "lg:justify-between",
    around: "lg:justify-around",
    evenly: "lg:justify-evenly",
    stretch: "lg:justify-stretch"
  }
}, a = {
  sm: {
    start: "items-start",
    end: "items-end",
    center: "items-center",
    baseline: "items-baseline",
    stretch: "items-stretch"
  },
  md: {
    start: "md:items-start",
    end: "md:items-end",
    center: "md:items-center",
    baseline: "md:items-baseline",
    stretch: "md:items-stretch"
  },
  lg: {
    start: "lg:items-start",
    end: "lg:items-end",
    center: "lg:items-center",
    baseline: "lg:items-baseline",
    stretch: "lg:items-stretch"
  }
}, m = {
  sm: {
    start: "self-start",
    end: "self-end",
    center: "self-center",
    baseline: "self-baseline",
    stretch: "self-stretch"
  },
  md: {
    start: "md:self-start",
    end: "md:self-end",
    center: "md:self-center",
    baseline: "md:self-baseline",
    stretch: "md:self-stretch"
  },
  lg: {
    start: "lg:self-start",
    end: "lg:self-end",
    center: "lg:self-center",
    baseline: "lg:self-baseline",
    stretch: "lg:self-stretch"
  }
}, c = {
  sm: {
    auto: "justify-self-auto",
    start: "justify-self-start",
    end: "justify-self-end",
    center: "justify-self-center",
    baseline: "justify-self-baseline",
    stretch: "justify-self-stretch"
  },
  md: {
    auto: "md:justify-self-auto",
    start: "md:justify-self-start",
    end: "md:justify-self-end",
    center: "md:justify-self-center",
    baseline: "md:justify-self-baseline",
    stretch: "md:justify-self-stretch"
  },
  lg: {
    auto: "lg:justify-self-auto",
    start: "lg:justify-self-start",
    end: "lg:justify-self-end",
    center: "lg:justify-self-center",
    baseline: "lg:justify-self-baseline",
    stretch: "lg:justify-self-stretch"
  }
}, n = {
  sm: {
    row: "flex-row",
    "row-reverse": "flex-row-reverse",
    column: "flex-col",
    "column-reverse": "flex-col-reverse"
  },
  md: {
    row: "md:flex-row",
    "row-reverse": "md:flex-row-reverse",
    column: "md:flex-col",
    "column-reverse": "md:flex-col-reverse"
  },
  lg: {
    row: "lg:flex-row",
    "row-reverse": "lg:flex-row-reverse",
    column: "lg:flex-col",
    "column-reverse": "lg:flex-col-reverse"
  }
}, i = {
  sm: {
    wrap: "flex-wrap",
    "wrap-reverse": "flex-wrap-reverse",
    nowrap: "flex-nowrap"
  },
  md: {
    wrap: "md:flex-wrap",
    "wrap-reverse": "md:flex-wrap-reverse",
    nowrap: "md:flex-nowrap"
  },
  lg: {
    wrap: "lg:flex-wrap",
    "wrap-reverse": "lg:flex-wrap-reverse",
    nowrap: "lg:flex-nowrap"
  }
}, f = {
  sm: {
    1: "w-full",
    2: "w-1/2",
    3: "w-1/3",
    4: "w-1/4",
    5: "w-1/5",
    6: "w-1/6",
    7: "w-1/7",
    8: "w-1/8",
    9: "w-1/9",
    10: "w-1/10",
    11: "w-1/11",
    12: "w-1/12"
  },
  md: {
    1: "md:w-full",
    2: "md:w-1/2",
    3: "md:w-1/3",
    4: "md:w-1/4",
    5: "md:w-1/5",
    6: "md:w-1/6",
    7: "md:w-1/7",
    8: "md:w-1/8",
    9: "md:w-1/9",
    10: "md:w-1/10",
    11: "md:w-1/11",
    12: "md:w-1/12"
  },
  lg: {
    1: "lg:w-full",
    2: "lg:w-1/2",
    3: "lg:w-1/3",
    4: "lg:w-1/4",
    5: "lg:w-1/5",
    6: "lg:w-1/6",
    7: "lg:w-1/7",
    8: "lg:w-1/8",
    9: "lg:w-1/9",
    10: "lg:w-1/10",
    11: "lg:w-1/11",
    12: "lg:w-1/12"
  }
}, p = {
  sm: {
    1: "order-1",
    2: "order-2",
    3: "order-3",
    4: "order-4",
    5: "order-5",
    6: "order-6",
    7: "order-7",
    8: "order-8",
    9: "order-9",
    10: "order-10",
    11: "order-11",
    12: "order-12",
    first: "order-first",
    last: "order-last",
    none: "order-none"
  },
  md: {
    1: "md:order-1",
    2: "md:order-2",
    3: "md:order-3",
    4: "md:order-4",
    5: "md:order-5",
    6: "md:order-6",
    7: "md:order-7",
    8: "md:order-8",
    9: "md:order-9",
    10: "md:order-10",
    11: "md:order-11",
    12: "md:order-12",
    first: "md:order-first",
    last: "md:order-last",
    none: "md:order-none"
  },
  lg: {
    1: "lg:order-1",
    2: "lg:order-2",
    3: "lg:order-3",
    4: "lg:order-4",
    5: "lg:order-5",
    6: "lg:order-6",
    7: "lg:order-7",
    8: "lg:order-8",
    9: "lg:order-9",
    10: "lg:order-10",
    11: "lg:order-11",
    12: "lg:order-12",
    first: "lg:order-first",
    last: "lg:order-last",
    none: "lg:order-none"
  }
}, w = {
  sm: {
    0: "grow-0",
    1: "grow"
  },
  md: {
    0: "md:grow-0",
    1: "md:grow"
  },
  lg: {
    0: "lg:grow-0",
    1: "lg:grow"
  }
}, u = {
  sm: {
    0: "shrink-0",
    1: "shrink"
  },
  md: {
    0: "md:shrink-0",
    1: "md:shrink"
  },
  lg: {
    0: "lg:shrink-0",
    1: "lg:shrink"
  }
};
export {
  a as alignClassNames,
  m as alignSelfClassNames,
  f as flexColumnClassNames,
  n as flexDirectionClassNames,
  w as flexGrowClassNames,
  p as flexOrderClassNames,
  u as flexShrinkClassNames,
  i as flexWrapClassNames,
  s as gapClassNames,
  e as gapXClassNames,
  r as gapYClassNames,
  t as gridColSpanClassNames,
  d as gridColStartClassNames,
  l as gridColumnClassNames,
  o as gridFlowClassNames,
  g as justifyClassNames,
  c as justifySelfClassNames
};
//# sourceMappingURL=container-styles.es.js.map
